import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';
import { InsightsColumn, TableRow } from '../Table';

const Cell = styled.td<{ grow?: number; minWidth?: number }>`
    display: flex;
    align-items: center;

    ${({ minWidth }) => minWidth && `min-width: ${minWidth}px;`}
    ${({ grow }) => grow && `flex: ${grow};`}
`;

const StyledSkeleton = styled(Skeleton)`
    transform: none;
    border-radius: 24px;
`;

interface Props {
    columns: InsightsColumn[];
    sizes?: number[];
}

export const ConversationRowSkeleton = ({ columns, sizes }: Props) => {
    return (
        <TableRow height="44px">
            {columns.map((column, index) => (
                <Cell grow={column.grow} minWidth={column.minWidth} key={index}>
                    <StyledSkeleton variant="text" width={sizes?.[index] || 100} height={14} />
                </Cell>
            ))}
        </TableRow>
    );
};
